module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"changeLanguage":"Skift til Dansk","comingSoon":"Coming Soon","profile":"Profile"}}')
  delete Component.options._Ctor
}
